export default __webpack_public_path__ + "media/images/street-view-1-hr-90fcb481bf9ace2e325fc068818c67ec.png";